module.exports = __webpack_public_path__ + "static/img/组 9@2x(4).60700444.png";